import { useMutation, useQueryClient } from '@tanstack/react-query'
import Cookies from 'js-cookie'
import { readSavedQueries, type SavedSearchConfig } from '@/lib/saved-search'

// 名前の検索クエリを削除
export function useDeleteSearchQuery(config: SavedSearchConfig) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (queryName: string) => {
      const savedQueries = readSavedQueries(config)
      const filteredQueries = savedQueries.filter((q) => q.name !== queryName)
      Cookies.set(config.cookieKey, JSON.stringify(filteredQueries), config.cookieOptions)
      return filteredQueries
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: config.queryKey() })
    },
  })
}
